import Layout from '@/layout/Index.vue'

export default [
  {
    path: '/purchaseInvoice',
    meta: { title: '采购单发票' },
    component: Layout,
    redirect: '/purchaseInvoice/list',
    children: [
      {
        path: 'list',
        meta: { title: '采购单发票', activeMenu: '/purchaseInvoice' },
        component: () => import('@/views/purchaseInvoice/PurchaseInvoice.vue')
      },
      {
        path: 'detail',
        meta: { title: '发票详情', activeMenu: '/purchaseInvoice' },
        component: () => import('@/views/purchaseInvoice/PurchaseInvoiceDetail.vue')
      },
      {
        path: 'add',
        meta: { title: '新增发票', activeMenu: '/purchaseInvoice' },
        component: () => import('@/views/purchaseInvoice/PurchaseInvoiceAdd.vue')
      },
      {
        path: 'edit',
        meta: { title: '编辑发票', activeMenu: '/purchaseInvoice' },
        component: () => import('@/views/purchaseInvoice/PurchaseInvoiceAdd.vue')
      }

    ]
  },
  {
    path: '/purchaseinvoicecount',
    meta: { title: '费用统计' },
    component: Layout,
    redirect: '/purchaseinvoicecount/list',
    children: [
      {
        path: 'list',
        meta: { title: '费用统计', activeMenu: '/purchaseinvoicecount' },
        component: () => import('@/views/purchaseInvoice/PurchaseInvoiceCount.vue')
      }
    ]
  },
  {
    path: '/quantitycount',
    meta: { title: '数量统计' },
    component: Layout,
    redirect: '/quantitycount/list',
    children: [
      {
        path: 'list',
        meta: { title: '数量统计', activeMenu: '/quantitycount' },
        component: () => import('@/views/purchaseInvoice/QuantityCount.vue')
      }
    ]
  },
  {
    path: '/orderpoundbill',
    meta: { title: '采购单磅单' },
    component: Layout,
    redirect: '/orderpoundbill/list',
    children: [
      {
        path: 'list',
        meta: { title: '采购单磅单', activeMenu: '/orderpoundbill' },
        component: () => import('@/views/purchaseInvoice/OrderPoundBill.vue')
      }
    ]
  }

]
